import React from "react";

type AvatarVariant = "circular" | "rounded" | "square";
type AvatarSize = "xs" | "sm" | "md" | "lg" | "xl" | "xxl";

interface AvatarProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  src: string;
  alt: string;
  variant?: AvatarVariant;
  size?: AvatarSize;
}

const variantClasses: Record<AvatarVariant, string> = {
  circular: "rounded-full",
  rounded: "rounded-lg",
  square: "rounded-none",
};

const sizeClasses: Record<AvatarSize, string> = {
  xs: "w-6 h-6",
  sm: "w-9 h-9",
  md: "w-12 h-12",
  lg: "w-16 h-16",
  xl: "w-20 h-20",
  xxl: "w-28 h-28",
};

export const Avatar: React.FC<AvatarProps> = ({
  src,
  alt,
  variant = "circular",
  size = "md",
  className = "",
  ...props
}) => {
  const variantClass = variantClasses[variant];
  const sizeClass = sizeClasses[size];

  return (
    <img
      src={src}
      alt={alt}
      className={`inline-block object-cover object-center ${variantClass} ${sizeClass} ${className}`}
      {...props}
    />
  );
};